<template>
  <v-expansion-panel>
    <v-expansion-panel-header>{{ $t('settingsView.privacy') }}</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-list
        disabled
        flat
        class="ma-0"
      >
        <v-list-item-group>
          <v-list-item
            v-for="(item, i) in privacyContent"
            :key="i"
          >
            <v-list-item-content>
              <h3
                v-if="item.heading !== undefined"
                class="mb-2"
              >
                {{ item.heading }}
              </h3>
              <v-list-item-title class="text-wrap">
                {{ item.title }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                <div v-if="item.content !== undefined">
                  {{ item.content }}
                </div>
                <div
                  v-for="(strongItem, j) in item.strongKVP"
                  :key="j+200"
                >
                  <br>
                  <strong>
                    {{ strongItem.heading }}
                  </strong>
                  <br>
                  {{ strongItem.content }}
                  <br>
                </div>
                <div v-if="item.ul !== undefined">
                  <ul>
                    <li
                      v-for="(li, k) in item.ul"
                      :key="k+300"
                      v-text="li"
                    />
                  </ul>
                </div>
                <div>
                  <div
                    v-for="(line, l) in item.contact"
                    :key="l+400"
                    v-text="line"
                  />
                  <br>
                </div>
                <div>
                  {{ item.contentEnd }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>

export default {
  name: 'Privacy',
  components: {
  },
  props: {},
  data() {
    return {
      privacyContent: this.$privacy,
    };
  },
  mounted() {
  },
  methods: {
  },
};

</script>
<style scoped>
</style>
